import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Chart, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "./style.css";
import "./FrequencyResponseFunction.css";
import zoomPlugin from 'chartjs-plugin-zoom';
import circle from './circle.png';
import { API_BASE_URL } from './config';
Chart.register(ChartDataLabels);
Chart.register(...registerables, zoomPlugin);

const GradingZ = () => {
  const navigate = useNavigate();

  const onMachineManagement = (e) => {
    e.preventDefault();
    navigate('/machine-management');
  };

  const onVFRF = (e) => {
    e.preventDefault();
    navigate('/view-frequency-response-function/z');
  };

  const { axis } = useParams();
  const [activeTab, setActiveTab] = useState(axis || "Z");

  useEffect(() => {
    setActiveTab(axis || "Z");
  }, [axis]);

  const [machineList, setMachineList] = useState([]);
  const [userDepartment, setUserDepartment] = useState(""); // 新增：狀態來儲存使用者部門
  
  useEffect(() => {
    // 從 localStorage 取得部門資訊
    const dept = localStorage.getItem("department"); 
    setUserDepartment(dept || ""); // 如果沒有找到，預設為空字串
  }, []);

  // 從後端取得機台資料
  const fetchMachineData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getdata/formData`);
      setMachineList(response.data);
    } catch (error) {
      console.error('獲取機台資料失敗:', error);
    }
  };

  const [showModal, setShowModal] = useState(false);

  //確保圖示資料中的內容都是最新的
  const handleShowModal = () => {
    fetchMachineData();
    setShowModal(true);
  };

  const [selectedMachines, setSelectedMachines] = useState([]);

  // 處理圖式資料中的勾選&取消勾選
  const handleCheckboxChange = (index) => {
    const selectedMachine = machineList.find((m) => m._id === index);
    if (!selectedMachine) return;
    if (selectedMachines.length === 0) {
      setSelectedMachines([index]);
    } else {
      const firstSelectedMachine = machineList.find((m) => m._id === selectedMachines[0]);
      if (firstSelectedMachine && firstSelectedMachine.machineModel.split('-')[0] === selectedMachine.machineModel.split('-')[0]) {
        setSelectedMachines((prevSelected) =>
          prevSelected.includes(index)
            ? prevSelected.filter((id) => id !== index)
            : [...prevSelected, index]
        );
      }
    }
  };

  const [coverData, setcoverData] = useState([]);
  const [lineLabels, setlineLabels] = useState([]);

  const [ok1, setOk1] = useState(0);
  const [other1, setOther1] = useState(0);
  const [ok2, setOk2] = useState(0);
  const [other2, setOther2] = useState(0);
  const [ok3, setOk3] = useState(0);
  const [other3, setOther3] = useState(0);
  const [ok4, setOk4] = useState(0);
  const [other4, setOther4] = useState(0);

  const [ok1MachineModel, setOk1MachineModel] = useState([]);
  const [other1MachineModel, setOther1MachineModel] = useState([]);
  const [ok2MachineModel, setOk2MachineModel] = useState([]);
  const [other2MachineModel, setOther2MachineModel] = useState([]);
  const [ok3MachineModel, setOk3MachineModel] = useState([]);
  const [other3MachineModel, setOther3MachineModel] = useState([]);
  const [ok4MachineModel, setOk4MachineModel] = useState([]);
  const [other4MachineModel, setOther4MachineModel] = useState([]);

  // 圖式資料 確認按鈕
  const handleConfirmSelection = () => {
    // 提取勾選的資料
    const newChartData = selectedMachines.map((machineId) => {
      const machine = machineList.find((m) => m._id === machineId);
      if (!machine) return null;// 如果找不到，跳過

      // 處理頻率&振幅
      const freq = Array.isArray(machine.updataZ.Amp_peak_data)? machine.updataZ.Amp_peak_data: [machine.updataZ.Amp_peak_data];
      const amplitude = Array.isArray(machine.updataZ.Amp_peak_freq_data)? machine.updataZ.Amp_peak_freq_data: [machine.updataZ.Amp_peak_freq_data];

      //將頻率&振幅的資料攤平成一維陣列
      const extractedFreq = freq.flat();
      const extractedAmplitude = amplitude.flat();

      return {
        machineModel: machine.machineModel,
        label: machine.updataZ.chartData.ch_name,
        amp_peak_data: extractedFreq,
        amp_peak_freq_data: extractedAmplitude,
        data: Array.isArray(machine.updataZ.chartData.magn)
          ? machine.updataZ.chartData.magn
          : [machine.updataZ.chartData.magn],
        fill: true,
        tension: 0.4,
        labels: machine.updataZ.chartData.freq,
        isOther1: false
      };
    }).filter(item => item !== null);

    setcoverData(newChartData);
    setlineLabels(newChartData[0]?.labels.slice(9) || []);
    setShowModal(false);

    let ok1 = 0;
    let other1 = 0;
    let ok2 = 0;
    let other2 = 0;
    let ok3 = 0;
    let other3 = 0;
    let ok4 = 0;
    let other4 = 0;

    let ok1MachineModel = [];
    let other1MachineModel = [];
    let ok2MachineModel = [];
    let other2MachineModel = [];
    let ok3MachineModel = [];
    let other3MachineModel = [];
    let ok4MachineModel = [];
    let other4MachineModel = [];

    if (newChartData.length > 0) {
      const firstSelectedMachine = machineList.find((m) => m._id === selectedMachines[0]);
      const baselineMachine = machineList.find((m) => {
        const currentModelPrefix = m.machineModel.split('-')[0];
        const selectedModelPrefix = firstSelectedMachine.machineModel.split('-')[0];
        return currentModelPrefix === selectedModelPrefix;
      });

      const firstFreqData = baselineMachine.updataZ.Amp_peak_freq_data;
      const firstAmpPeakData = baselineMachine.updataZ.Amp_peak_data;

      newChartData.forEach((item) => {
        let isOtherA1 = false;
        let isOtherA2 = false;
        let isOtherA3 = false;
        let isOtherA4 = false;

        if (item.amp_peak_data && item.amp_peak_freq_data) {
          const ampResults = [];
          let sum = 0;

          item.amp_peak_data.forEach((ampValue, i) => {
            const freqValue = item.amp_peak_freq_data[i];
            const matchIndex = firstFreqData.findIndex(baseFreq => {
              return Math.abs(freqValue - baseFreq) <= 1;
            });
            if (matchIndex !== -1) {
              const baseAmp = firstAmpPeakData[matchIndex];
              const result = ((ampValue - baseAmp) / baseAmp) * 100;
              if (!isNaN(result)) {
                ampResults.push(result);
                sum += result;
              }
            }
          });

          const average = ampResults.length > 0 ? sum / ampResults.length : 0;

          isOtherA1 = !(average >= -10 && average <= -6);
          isOtherA2 = !(average > -6 && average <= 0);
          isOtherA3 = !(average > 0 && average <= 5);
          isOtherA4 = !(average > 5 && average <= 10);
        }

        item.isOtherA1 = isOtherA1;
        item.isOtherA2 = isOtherA2;
        item.isOtherA3 = isOtherA3;
        item.isOtherA4 = isOtherA4;

        if (!isOtherA1) {
          ok1++;
          ok1MachineModel.push(item.machineModel);
        } else {
          other1++;
          other1MachineModel.push(item.machineModel);
        }

        if (!isOtherA2) {
          ok2++;
          ok2MachineModel.push(item.machineModel);
        } else {
          other2++;
          other2MachineModel.push(item.machineModel);
        }

        if (!isOtherA3) {
          ok3++;
          ok3MachineModel.push(item.machineModel);
        } else {
          other3++;
          other3MachineModel.push(item.machineModel);
        }

        if (!isOtherA4) {
          ok4++;
          ok4MachineModel.push(item.machineModel);
        } else {
          other4++;
          other4MachineModel.push(item.machineModel);
        }
      });
    }

    setOk1(ok1);
    setOther1(other1);
    setOk2(ok2);
    setOther2(other2);
    setOk3(ok3);
    setOther3(other3);
    setOk4(ok4);
    setOther4(other4);
    setOk1MachineModel(ok1MachineModel);
    setOther1MachineModel(other1MachineModel);
    setOk2MachineModel(ok2MachineModel);
    setOther2MachineModel(other2MachineModel);
    setOk3MachineModel(ok3MachineModel);
    setOther3MachineModel(other3MachineModel);
    setOk4MachineModel(ok4MachineModel);
    setOther4MachineModel(other4MachineModel);

    localStorage.setItem("selectedMachinesGZ", JSON.stringify(selectedMachines));
    localStorage.setItem("coverDataGZ", JSON.stringify(newChartData));
    localStorage.setItem("ok1GZ", JSON.stringify(ok1));
    localStorage.setItem("other1GZ", JSON.stringify(other1));
    localStorage.setItem("ok2GZ", JSON.stringify(ok2));
    localStorage.setItem("other2GZ", JSON.stringify(other2));
    localStorage.setItem("ok3GZ", JSON.stringify(ok3));
    localStorage.setItem("other3GZ", JSON.stringify(other3));
    localStorage.setItem("ok4GZ", JSON.stringify(ok4));
    localStorage.setItem("other4GZ", JSON.stringify(other4));
    localStorage.setItem("ok1MachineModelGZ", JSON.stringify(ok1MachineModel));
    localStorage.setItem("other1MachineModelGZ", JSON.stringify(other1MachineModel));
    localStorage.setItem("ok2MachineModelGZ", JSON.stringify(ok2MachineModel));
    localStorage.setItem("other2MachineModelGZ", JSON.stringify(other2MachineModel));
    localStorage.setItem("ok3MachineModelGZ", JSON.stringify(ok3MachineModel));
    localStorage.setItem("other3MachineModelGZ", JSON.stringify(other3MachineModel));
    localStorage.setItem("ok4MachineModelGZ", JSON.stringify(ok4MachineModel));
    localStorage.setItem("other4MachineModelGZ", JSON.stringify(other4MachineModel));
  };

  // 頁面刷新後，恢復資料
  useEffect(() => {
    const savedSelectedMachines = JSON.parse(localStorage.getItem("selectedMachinesGZ"));
    const savedCoverData = JSON.parse(localStorage.getItem("coverDataGZ"));
    const savedOk1 = JSON.parse(localStorage.getItem("ok1GZ"));
    const savedOther1 = JSON.parse(localStorage.getItem("other1GZ"));
    const savedOk2 = JSON.parse(localStorage.getItem("ok2GZ"));
    const savedOther2 = JSON.parse(localStorage.getItem("other2GZ"));
    const savedOk3 = JSON.parse(localStorage.getItem("ok3GZ"));
    const savedOther3 = JSON.parse(localStorage.getItem("other3GZ"));
    const savedOk4 = JSON.parse(localStorage.getItem("ok4GZ"));
    const savedOther4 = JSON.parse(localStorage.getItem("other4GZ"));

    const savedOk1MachineModel = JSON.parse(localStorage.getItem("ok1MachineModelGZ"));
    const savedOther1MachineModel = JSON.parse(localStorage.getItem("other1MachineModelGZ"));
    const savedOk2MachineModel = JSON.parse(localStorage.getItem("ok2MachineModelGZ"));
    const savedOther2MachineModel = JSON.parse(localStorage.getItem("other2MachineModelGZ"));
    const savedOk3MachineModel = JSON.parse(localStorage.getItem("ok3MachineModelGZ"));
    const savedOther3MachineModel = JSON.parse(localStorage.getItem("other3MachineModelGZ"));
    const savedOk4MachineModel = JSON.parse(localStorage.getItem("ok4MachineModelGZ"));
    const savedOther4MachineModel = JSON.parse(localStorage.getItem("other4MachineModelGZ"));

    if (savedSelectedMachines && savedCoverData) {
      setSelectedMachines(savedSelectedMachines);
      setcoverData(savedCoverData);
      setlineLabels(savedCoverData[0]?.labels.slice(9) || []);

      setOk1(savedOk1 || 0);
      setOther1(savedOther1 || 0);
      setOk2(savedOk2 || 0);
      setOther2(savedOther2 || 0);
      setOk3(savedOk3 || 0);
      setOther3(savedOther3 || 0);
      setOk4(savedOk4 || 0);
      setOther4(savedOther4 || 0);

      setOk1MachineModel(savedOk1MachineModel || []);
      setOther1MachineModel(savedOther1MachineModel || []);
      setOk2MachineModel(savedOk2MachineModel || []);
      setOther2MachineModel(savedOther2MachineModel || []);
      setOk3MachineModel(savedOk3MachineModel || []);
      setOther3MachineModel(savedOther3MachineModel || []);
      setOk4MachineModel(savedOk4MachineModel || []);
      setOther4MachineModel(savedOther4MachineModel || []);
    }
  }, []);

  const lineChartRef = useRef(null);

  // 折線圖
  const createLineChart = (chartRef, datasets) => {
    const chartInstance = new Chart(lineChartRef.current, {
      type: "line",
      data: { labels: chartRef, datasets: datasets },
      options: {
        layout: { padding: { right: -80 } }, // 折線圖 圖例位置
        scales: {
          y: {
            ticks: { beginAtZero: true },
            title: { display: true, text: 'Amplitude (μm/N)', font: { size: 14 }, padding: 15 }
          },
          x: {
            type: 'linear',
            min: 15, max: 200,
            title: { display: true, text: 'Frequency (Hz)', font: { size: 14 }, padding: 15 },
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              callback: function (value) {
                return Math.round(value);
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        fill: true,
        elements: {
          point: { radius: 0, hitRadius: 10 },
          line: { tension: 0.4 }
        },
        plugins: {
          legend: {
            position: 'bottom',
            display: true,
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              font: { size: 13 } // 折線圖圖例尺寸
            },
            onClick: (e, legendItem, legend) => {
              const datasetIndex = legendItem.datasetIndex;
              const chart = legend.chart;

              const meta = chart.getDatasetMeta(datasetIndex);
              meta.hidden = !meta.hidden;
              const isHidden = meta.hidden;

              const dataset = chart.data.datasets[datasetIndex];
              const machineModel = dataset.machineModel;

              const groups = [
                {
                  isOther: dataset.isOtherA1,
                  setOk: setOk1,
                  setOkMachineModel: setOk1MachineModel,
                  setOther: setOther1,
                  setOtherMachineModel: setOther1MachineModel,
                },
                {
                  isOther: dataset.isOtherA2,
                  setOk: setOk2,
                  setOkMachineModel: setOk2MachineModel,
                  setOther: setOther2,
                  setOtherMachineModel: setOther2MachineModel,
                },
                {
                  isOther: dataset.isOtherA3,
                  setOk: setOk3,
                  setOkMachineModel: setOk3MachineModel,
                  setOther: setOther3,
                  setOtherMachineModel: setOther3MachineModel,
                },
                {
                  isOther: dataset.isOtherA4,
                  setOk: setOk4,
                  setOkMachineModel: setOk4MachineModel,
                  setOther: setOther4,
                  setOtherMachineModel: setOther4MachineModel,
                }
              ];

              groups.forEach(({ isOther, setOk, setOkMachineModel, setOther, setOtherMachineModel }) => {
                const count = isOther ? setOther : setOk;
                const modelSetter = isOther ? setOtherMachineModel : setOkMachineModel;

                if (isHidden) {
                  count(prev => prev - 1);
                  modelSetter(prev => {
                    if (!Array.isArray(prev)) return prev;
                    const index = prev.indexOf(machineModel);
                    if (index !== -1) {
                      const newList = [...prev];
                      newList.splice(index, 1);
                      return newList;
                    }
                    return prev;
                  });
                } else {
                  count(prev => prev + 1);
                  modelSetter(prev => [...prev, machineModel]);
                }
              });

              chart.update();
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                const label = context.dataset.label || '';
                const xValue = context.label;
                const yValue = context.raw.toFixed(4);
                return `${label}   ( ${xValue} , ${yValue} )`;
              },
              title: function () {
                return '';
              }
            }
          },
          datalabels: { display: false },
          zoom: {
            pan: {
              enabled: false,
            },
            zoom: {
              wheel: { enabled: false },
              pinch: { enabled: false },
              mode: 'x',
              drag: {
                enabled: true,
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                threshold: 2,
                delay: 50
              }
            },
            onZoom: ({ chart }) => {
              let xScale = chart.scales.x;
              let min = Math.max(xScale.min, 15);
              let max = Math.min(xScale.max, 200);

              chart.options.scales.x.min = min;
              chart.options.scales.x.max = max;
              chart.options.scales.x.ticks.stepSize = 5;
              chart.update();
            }
          }
        }
      }
    });
    lineChartRef.current.chartInstance = chartInstance;
    return chartInstance;
  };

  const resetZoom = () => {
    if (lineChartRef.current && lineChartRef.current.chartInstance) {
      lineChartRef.current.chartInstance.resetZoom();
    }
  };

  // 確保折線圖創建
  useEffect(() => {
    let lineChart;
    if (lineChartRef.current) lineChart?.destroy();
    lineChart = createLineChart(lineLabels, coverData);
    return () => {
      lineChart?.destroy();
    };
  }, [coverData]);

  // 當切換到不同軸向時，能夠重新處理選中的機台數據，並更新折線圖
  useEffect(() => {
    if (selectedMachines.length > 0) {
      handleConfirmSelection();
    }
  }, [activeTab]);


  const colors = {
    color1: "rgb(240, 173, 167)",
    color2: "rgb(254, 214, 144)",
    color3: "rgb(124, 166, 217)",
    color4: "rgb(180, 218, 134)"
  };

  // 圓餅圖
  const generateChartData = (ok, other, label, color, okMachineModel, otherMachineModel) => ({
    data: {
      labels: [label, "other"],
      datasets: [{
        data: [ok, other],
        backgroundColor: [color, "rgb(202, 213, 224)"],
        okMachineModel: okMachineModel,
        otherMachineModel: otherMachineModel
      }]
    },
    options: {
      maintainAspectRatio: false,
      cutout: 22, // 圓餅圖 胖度
      plugins: {
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            usePointStyle: true,
            pointStyle: 'rect',
            padding: 40, // 圓餅圖 圖例位置
            font: {
              size: 13 // 圓餅圖 圖例大小
            }
          },
          onClick: () => { }
        },
        datalabels: {
          display: true,
          color: '#ffffff',
          font: { size: 15 }, // 圓餅圖 %數值尺寸
          formatter: (value, context) => {
            const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            const percentage = ((value / total) * 100).toFixed(0);
            return `${percentage}%`;
          }
        },
        tooltip: {
          enabled: false, // 禁用內建 tooltip，使用自訂 tooltip
          external: function (context) {
            let tooltipEl = document.getElementById("chart-tooltip");

            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chart-tooltip";
              tooltipEl.style.position = "absolute";
              tooltipEl.style.background = "rgba(0, 0, 0, 0.8)";
              tooltipEl.style.color = "white";
              tooltipEl.style.padding = "8px";
              tooltipEl.style.borderRadius = "5px";
              tooltipEl.style.fontSize = "13px";
              tooltipEl.style.pointerEvents = "none";
              tooltipEl.style.transition = "opacity 0.2s";
              tooltipEl.style.zIndex = "3"; // 確保 tooltip 顯示在最上層
              document.body.appendChild(tooltipEl);
            }

            const tooltipModel = context.tooltip;
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = "0";
              return;
            }

            const dataPoint = tooltipModel.dataPoints[0];
            const dataset = dataPoint.dataset;

            let tooltipText = "";
            if (dataPoint.label === label) {
              tooltipText = ` ${dataset.okMachineModel}`;
            } else if (dataPoint.label === "other") {
              tooltipText = ` ${dataset.otherMachineModel}`;
            }

            tooltipEl.innerHTML = tooltipText; //套用給tooltip的內容，上一段為內容的宣告
            tooltipEl.style.opacity = "1"; //tooltip透明度，範圍0-1

            // 正確計算 tooltip 位置，在滑鼠附近顯示
            document.addEventListener("mousemove", (event) => {
              tooltipEl.style.left = `${event.clientX + 15}px`;
              tooltipEl.style.top = `${event.clientY + 5}px`;
            });
          }
        }
      }
    }
  });

  const data1 = generateChartData(ok1, other1, "-10% ~ -6%", colors.color1, ok1MachineModel, other1MachineModel);
  const data2 = generateChartData(ok2, other2, "-5% ~ 0%", colors.color2, ok2MachineModel, other2MachineModel);
  const data3 = generateChartData(ok3, other3, "1% ~ 5%", colors.color3, ok3MachineModel, other3MachineModel);
  const data4 = generateChartData(ok4, other4, "6% ~ 10%", colors.color4, ok4MachineModel, other4MachineModel);

  //圖示資料 全選功能
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleToggleSelectAll = () => {
    const modelPrefix = machineList.find(m => m._id === selectedMachines[0])?.machineModel.split('-')[0];
    if (!isAllSelected) {
      const sameModelMachines = machineList
        .filter(machine => machine.machineModel.split('-')[0] === modelPrefix)
        .map(machine => machine._id);

      setSelectedMachines(sameModelMachines);
      setIsAllSelected(true);
    } else {
      setSelectedMachines([]);
      setIsAllSelected(false);
    }
  };

  return (
    <div>
      <div className="d-flex" style={{ width: '81.7%', margin: '0 auto' }}>
        <div className="container-fluid">
          <div style={{ height: '35px', width: '100%' }}></div>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#" onClick={onMachineManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>機台資料庫</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#" onClick={onVFRF} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>頻率響應函數</a>
              </li>
              <li
                className="breadcrumb-item"
                aria-current="page"
                style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>等級分析
              </li>
            </ol>
          </nav>

          <div className="d-flex justify-content-end" style={{ paddingRight: '20px' }}>
            <button
              className="reset-btn btn-margin-sm bi bi-arrow-clockwise"
              onClick={resetZoom}
            >
            </button>

            <button
              className="btn2 btn-margin-sm"
              style={{ height: '35px', width: '75px' }}
              onClick={() => { setShowModal(true); handleShowModal(); }}
            >
              圖示資料
            </button>
          </div>

          <nav>
            <div className="nav nav-tabs" role="tablist">
              {["X", "Y", "Z"].map((axis) => (
                <Link
                  key={axis}
                  to={`/grading-frequency-response-function/${axis.toLowerCase()}`}
                  className={`nav-link ${activeTab === axis ? "active" : ""}`}
                >
                  {axis}軸向
                </Link>
              ))}
            </div>
          </nav>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "50px", flexWrap: "wrap", gap: "20px" }}>
            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut
                data={data1.data}
                options={data1.options}
                style={{ zIndex: 2, pointerEvents: "auto" }} // 確保圓餅圖可以接收事件
              />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none" // 讓圖片不影響滑鼠事件
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data2.data} options={data2.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data3.data} options={data3.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>

            <div style={{ position: "relative", width: "257px", height: "200px", display: "flex", justifyContent: "center" }}>
              <Doughnut data={data4.data} options={data4.options} />
              <img
                src={circle}
                alt="circle"
                style={{
                  width: "180px",
                  height: "180px",
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }}
              />
            </div>
          </div>

          <div style={{ height: '45px', width: '100%' }}></div>

          <Modal show={showModal} onHide={() => setShowModal(false)} scrollable>
            <Modal.Header closeButton>
              <Modal.Title>圖示資料選擇</Modal.Title>
              {selectedMachines.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className={`select-model-button ${isAllSelected ? 'cancel' : 'select'}`}
                    onClick={handleToggleSelectAll}
                    style={{
                      padding: '2px 10px',
                      height: '28px',
                      lineHeight: '1.2',
                      marginLeft: '12px',
                      marginTop: '15px'
                    }}
                  >
                    {isAllSelected
                      ? '取消全選'
                      : `全選：${machineList.find(m => m._id === selectedMachines[0])?.machineModel.split('-')[0]}`}
                  </Button>
                </div>
              )}
            </Modal.Header>
            <Modal.Body>
              {machineList
                .filter((machine) => {
                  return machine.department === userDepartment;
                })
                .map((machine) => {
                  const isDisabled = selectedMachines.length > 0 && (
                    machineList.find((m) => m._id === selectedMachines[0]).machineModel.split('-')[0] !== machine.machineModel.split('-')[0]
                  );
                  return (
                    <div
                      key={machine._id}
                      style={{ marginBottom: '10px' }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={machine._id}
                        id={`modal-machine-${machine._id}`}
                        checked={selectedMachines.includes(machine._id)}
                        onChange={() => handleCheckboxChange(machine._id)}
                        disabled={isDisabled}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`modal-machine-${machine._id}`}
                        style={{ marginLeft: '10px', color: isDisabled ? '#A9A9A9' : '#636363' }}
                      >
                        {machine.updataZ.chartData.filename}
                      </label>
                    </div>
                  );
                })
              }
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center gap-4">
              <Button
                className="btn-cancel"
                style={{ height: '35px', width: '75px' }}
                onClick={() => setShowModal(false)}
              >
                取消
              </Button>
              <Button
                variant="btn-confirm btn-primary"
                style={{ height: '35px', width: '75px' }}
                onClick={handleConfirmSelection}
              >
                確認
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div >

      <div className="d-flex" style={{ width: '81.7%', height: "480px", margin: '0 auto' }}>
        <canvas ref={lineChartRef}></canvas>
      </div>
      <div style={{ height: '35px', width: '100%' }}></div>
    </div >
  );
};

export default GradingZ;